import { Grid, Typography } from '@mui/material';
import ImageInfoDownload from '../../OverviewView/ImageInfoDownload';
import GridContainer from '../../Filter/Components/grid/GridContainer';


interface IEnhancedTableToolbarProps {
    confirmationButton: React.ReactElement,
    style?: React.CSSProperties,
    selected: number,
    onDownloadClick?: ((downloadOptions: any) => void),
}

const EnhancedTableToolbar = (props: IEnhancedTableToolbarProps) => {

    const { selected } = { ...props }

    return (
        <GridContainer container style={props.style}>
            <Grid item xs={3} md={2} style={{position: "relative"}}>
                <Typography
                    sx={{ position: "absolute", top: "25%" }}
                    color={"#898989"}
                    component="div"
                >
                    {selected} selected
                </Typography>
            </Grid>
            <Grid item xs={9} md={10} textAlign={"left"} style={{display: "inline-flex"}}>
                {props.onDownloadClick ? <ImageInfoDownload onDownloadClick={props.onDownloadClick} /> : null}
                {props.confirmationButton}
            </Grid>
        </GridContainer>
    );
}

export default EnhancedTableToolbar;

